import React, { Component } from "react";
import "./ShowHide.css";

export default class ShowHide extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showingFull: false,
    };

    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(e) {
    e.preventDefault();

    this.setState({ showingFull: !this.state.showingFull });
  }

  render() {
    return (
      <div className="see-more" style={{ width: "100%" }}>
        <button className="see-more-button" onClick={this.handleClick}>
          {this.state.showingFull
            ? this.props.retractMessage
            : this.props.expandMessage}
        </button>
        <div
          className="see-more-content"
          style={{
            display: this.state.showingFull ? "block" : "none",
            width: "100%",
          }}
        >
          {this.props.children}
        </div>

        {this.props.secondCloseAtBottom && this.state.showingFull ? (
          <button className="see-more-button" onClick={this.handleClick}>
            {this.state.showingFull
              ? this.props.retractMessage
              : this.props.expandMessage}
          </button>
        ) : null}
      </div>
    );
  }
}
